enum TokenSubscribeEnum {
    ROLE_ELCI = "ROLE_ELCI",
    ROLE_SIGNATURE = "ROLE_SIGNATURE",
    ROLE_RGPD = "ROLE_RGPD",
    ROLE_ACTIVATE = "ROLE_ACTIVATE",
    ROLE_USER_DISABLED = "ROLE_USER_DISABLED"
  }

  export default TokenSubscribeEnum;